module.exports = __webpack_public_path__ + "static/media/implant.ee471345.svg";